<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      width="900px"
      :title="$t('CargoMsg.Cargo_Preview')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="headList.gridOptions"
          :column-defs="headList.columnDefs"
          :row-data="headListRowData"
          :style="{width:'100%',height:'150px'}"
        />
      </div>
      <div class="app-main-inner-row row-grid" style="padding-top: 60px">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="detailList.gridOptions"
          :column-defs="detailList.columnDefs"
          :row-data="detailListRowData"
          :style="{width:'100%',height:'200px'}"
        />
      </div>
      <div v-if="fileListRowData.length > 0" class="app-main-inner-row row-grid" style="padding-top: 10px">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="fileList.gridOptions"
          :column-defs="fileList.columnDefs"
          :row-data="fileListRowData"
          :style="{width:'100%',height:'200px'}"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="innerVisible=false">{{ $t('FinanceManage.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'ShowPreviewDialog',
  props: {
    visible: { type: Boolean, required: true },
    headListRowData: { type: Array, required: false, default: () => [] },
    detailListRowData: { type: Array, required: false, default: () => [] },
    fileListRowData: { type: Array, required: false, default: () => [] }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      headList: {
        gridOptions: {},
        gridParams: {},
        gridApi: {},
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_OrganizeClearing'), field: 'accountId', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_DocumentCode'), field: 'tentativeEstimateNo', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_BillDate2'), field: 'accountingDate', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_EndDate2'), field: 'dueDate', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_TypeOfExchange'), field: 'exchangeType', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_CurrentAccountCode'), field: 'exchangeNo', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Priority'), field: 'priority', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_PE'), field: 'preliminaryEstimate', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_DocumentId'), field: 'jobNo', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_SourceSystemCoding'), field: 'sourceCode', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_businessShipAgency'), field: 'lob', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_CoinsReceivable'), field: 'currency', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'), field: 'exchangeRate', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_TaxAmount'), field: 'taxAmount', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Amount'), field: 'amount', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_ArApAmount'), field: 'excludingTaxAmount', width: 150 }
        ]
      },
      detailList: {
        gridOptions: {},
        gridParams: {},
        gridApi: {},
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_CostItem'), field: 'chargeItem', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Details') + '.' + this.$t('CargoMsg.Cargo_UnitOfMeasurement'), field: 'measure', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Details') + '.' + this.$t('CargoMsg.Cargo_AmountNumber'), field: 'detailQuantity', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Details') + '.' + this.$t('CargoMsg.Cargo_UnitPrice'), field: 'unitRate', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_UnitPrice2'), field: 'unitPrice', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Details') + '.' + this.$t('CargoMsg.Cargo_TaxRateCode'), field: 'taxRateCode', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Details') + '.' + this.$t('CargoMsg.Cargo_TaxAmount'), field: 'taxAmount', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Details') + '.' + this.$t('CargoMsg.Cargo_Discount'), field: 'discountMode', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Details') + '.' + this.$t('CargoMsg.Cargo_Amount'), field: 'amount', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_Details') + '.' + this.$t('CargoMsg.Cargo_ArAmount'), field: 'receivableAmount', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_MonthCode'), field: 'monthCode', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_TaxPolicyCoding'), field: 'taxPolicyCode', width: 150 }
        ]
      },
      fileList: {
        gridOptions: {},
        gridParams: {},
        gridApi: {},
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_AttachmentName'), field: 'fileName', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_AccessoriesAddress'), field: 'remarks', width: 300 }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

